import PropTypes from 'prop-types';

import './SignInModal.css';

import ModalBase from '../ModalBase';

const signInModalStyles = {
	content: {
		width: '600px',
		maxHeight: '100%',
		height: '140px',
	},
};

/**
 * Sign In and Sign Up modal
 * @component
 */
const SignInModal = ({ isOpen, onRequestClose }) => {
	return (
		<ModalBase className="modal-signin" isOpen={isOpen} style={signInModalStyles} onRequestClose={onRequestClose}>
			<div className="panel-left">
				<div className="content-wrapper">
					<div className="head">Sign in with…</div>
					<div className="content">
						<a className="google-signin" href="/login/google">
							Sign in with Google
						</a>
					</div>
				</div>
			</div>
			<div className="panel-right">
				<div className="content-wrapper">
					<div className="head">Sign in using account</div>
					<div className="content">not supported yet…</div>
				</div>
			</div>
		</ModalBase>
	);
};

SignInModal.propTypes = {
	// Open state
	isOpen: PropTypes.bool,
	// Callback on close dialog request
	onRequestClose: PropTypes.func,
};

export default SignInModal;
